import { NgModule } from '@angular/core';
import { MuiButtonModule } from '../button';
import { MuiIconModule } from '../icon';
import { MuiListItemAction } from './item/mui-list-item-action.component';
import { MuiListItemIcon } from './item/mui-list-item-icon.component';
import { MuiListItemLabel } from './item/mui-list-item-label.component';
import { MuiListItem } from './item/mui-list-item.component';
import { MuiListHeader } from './mui-list-header.component';
import { MuiList } from './mui-list.component';


@NgModule({
  imports: [
    MuiIconModule,
    MuiButtonModule
  ],
  declarations: [
    MuiList,
    MuiListItem,
    MuiListItemIcon,
    MuiListItemLabel,
    MuiListItemAction,
    MuiListHeader
  ],
  exports: [
    MuiList,
    MuiListItem,
    MuiListItemIcon,
    MuiListItemLabel,
    MuiListItemAction,
    MuiListHeader
  ]
})
export class MuiListModule {
}
